<div class="self-contact-dialog">
  <h2 mat-dialog-title>Create Your Self Contact</h2>
  <div mat-dialog-content>
    <p class="dialog-message">
      To use Private Lending Strategies effectively, you need to create a "Self" contact. This contact represents you in the system and is required for various transactions.
    </p>
    
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="first_name" required>
        @if (contactForm.get('first_name')?.hasError('required')) {
          <mat-error>
            First name is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="last_name" required>
        @if (contactForm.get('last_name')?.hasError('required')) {
          <mat-error>
            Last name is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Organization (Optional)</mat-label>
        <input matInput formControlName="organization">
      </mat-form-field>
    </form>
  </div>
  
  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSubmit()" 
      [disabled]="contactForm.invalid || loading">
      @if (loading) {
        <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      } @else {
        <span>Create Self Contact</span>
      }
    </button>
  </div>
</div>
